import TitleScreenCrud from '../../../shared/TitleScreenCrud';
import MDInput from '../../../shared/MDInput';
import * as React from 'react';
import contratacaoTableData from './ContratacaoTableData';
import DataTable from '../../../shared/Tables/DataTable';
import { Button } from '@mui/material';
import { Link, useNavigate   } from 'react-router-dom';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { ContainerGoCadastro } from '../../../../layouts/turma/screens/Listscreen/TurmaForm.styled';
import { getByID } from '../../../../layouts/contratacao/ContratacaoService';
import InativarModal from '../../../../layouts/shared/InativarModal';

export default function ContratacaoForm(){
  const [clickedRowIndex, setClickedRowIndex] = React.useState(null); 
  const [currentPage, setCurrentPage] = React.useState(0);  
  const [searchFilter, setSearchFilter] = React.useState(null);  
  const [typeBotton, setTypeBotton] = React.useState('');   
  const [objFull, setObjFull] = React.useState([]);
  const [idContratacaoInativar, setIdContratacaoInativar] = React.useState([]);
  const [showModalInativar, setShowModalInativar] = React.useState(false);
  const navigate = useNavigate();

  const handleTypeBotton = (rowIndex) => {
    setTypeBotton(rowIndex);
  };

  const handleObjFull = (obj) => {            
    setObjFull(obj);
  }  

  const { columns, rows } = contratacaoTableData(searchFilter, handleTypeBotton, handleObjFull);  

  const customInputStyle = {
    width: '100%',
    padding: 26,
    marginTop: -16 
  };

  const alignEndItem = {   
    width: 'auto',
    height: 'auto',
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    alignSelf: 'flex-end',
    marginRight: window.window.innerWidth < 768 ? 38 : 48,
    marginBottom: 12,
    marginTop: window.window.innerWidth < 768 ? -70 : 0
  };  

  const handlePrepareData = (value: string) => {
    console.log('value handlePrepare ', value);   
    setSearchFilter(value); 
  }

  const handleRowClick = (rowIndex) => {
    setClickedRowIndex(rowIndex);
  };    

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleCallWhatsApp = async () => {            
    const rangeInfo = currentPage * 5;    
    const newObj = [];
    objFull.map((result, index) => {      
      if (index+1 > (rangeInfo-5) && index < (rangeInfo)){
        newObj.push(result);
      }
    }) 
    
    await getByID(newObj[clickedRowIndex].titularId)
      .then((result) => {        
        window.open(`https://web.whatsapp.com/send/?phone=${result.data.telefoneCelular}`);
      })            
  }

  async function handleInativarContratacao(){        
    const rangeInfo = currentPage * 5;    
    const newObj = [];
    objFull.map((result, index) => {      
      if (index+1 > (rangeInfo-5) && index < (rangeInfo)){
        newObj.push(result);
      }
    })        
    setIdContratacaoInativar(newObj[clickedRowIndex].id);            
    setShowModalInativar(true);
    setTypeBotton('');
  }

  React.useEffect(() => {
    if (typeBotton === 'Editar'){
      handleCallWhatsApp();      
      setTypeBotton('');
    }else if  (typeBotton === 'Inativar'){
      handleInativarContratacao()
    }
  }, [typeBotton]);  

  const handleReturnInativar = (value) => {  
    (value === true) && window.location.reload();
    setShowModalInativar(false);
  }

  return(
    <TitleScreenCrud title={'Contratações'}>  
      { showModalInativar && <InativarModal screen='Contratação' returnInativar={handleReturnInativar} idContratacao={idContratacaoInativar}/> }
      <MDInput style={customInputStyle} onChange={(event) => {handlePrepareData(event.target.value)}}                 
        placeholder="Filtrar"
      >
      </MDInput>  
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={true}
        showTotalEntries={false}
        noEndBorder
        onRowClick={handleRowClick} 
        pageNumber={handlePageChange}
      />
      <ContainerGoCadastro>        
        <Link to={'/contratacoes/cadContratacao'} style={alignEndItem}>
          <Button style={{ width: 50, height: 50, backgroundColor: '#FFF', borderRadius: 50 }}>
            <AddCircleRoundedIcon style={{ width: 40, height: 40, color: '#ba79e1' }}/>                      
          </Button>
        </Link>
      </ContainerGoCadastro>
          
    </TitleScreenCrud> 
  )
}